/** Maps Ticket enum status keys to shared Badge variants. */
export const TICKET_STATUS_BADGE_VARIANT = {
  submitted: "neutral",
  open: "accent",
  assigned: "warning",
  cancelled: "warning",
  closed: "success",
};

// Ordered rules matched against the mapped, client-facing status label
// (see Connectwise::StatusDisplay). First match wins, so more specific /
// terminal states are listed first.
const STATUS_NAME_VARIANTS = [
  { match: /closed|resolved/i, variant: "success" },
  { match: /cancel/i, variant: "warning" },
  { match: /waiting|escalated|pending/i, variant: "warning" },
  { match: /progress|assigned|scheduled|updated|day 1 call|open/i, variant: "accent" },
  { match: /new|submitted|shipped/i, variant: "neutral" },
];

/**
 * @param {string} [statusKey] Ticket enum key from Rails
 * @param {string} [statusName] ConnectWise display name
 */
export function ticketStatusBadgeVariant(statusKey, statusName) {
  if (statusName) {
    const byName = STATUS_NAME_VARIANTS.find(({ match }) => match.test(statusName));
    if (byName) return byName.variant;
  }

  return TICKET_STATUS_BADGE_VARIANT[statusKey] ?? "neutral";
}
